import React, { useState, useEffect } from "react";
import API_BASE_URL from "../config";
import axios from "axios";

export default function Fileuploader(props) {
  const [uploadMessage, setUploadMessage] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);

  return (
    <div>
      <div className="row mx-3">
        <div className="container">
          <div className="row">
            <div className="col-6">
              <input
                type="file"
                accept="image/jpeg,image/png"
                disabled="true"
              />
            </div>
            <div className="col-6">
              <button
                className="btn btn-secondary btn-circle btn-sm"
                title="Upload File"
                disabled="true"
              >
                <i className="fas fa-upload"></i>
              </button>
            </div>
          </div>
          <div>
            <p className="small mt-2">
              Note: Choose a file with .pdf, .jpg, .png file extension
            </p>
          </div>
          {uploadProgress > 0 && uploadProgress < 100 && (
            <div>
              <p>Upload Progress: {uploadProgress}%</p>
              <progress value={uploadProgress} max="100" />
            </div>
          )}
          {uploadMessage && <p className="small">{uploadMessage}</p>}
        </div>
      </div>
    </div>
  );
}
